import MainTitlePurple from "./MainTitlePurple";
export default MainTitlePurple;
